<template>
    <v-container fluid class="px-0 pt-16 px-md-1">
      <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
          <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
          <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
          <p class="w-1/3 text-center text-white">
              Esto puede tardar unos segundos.
          </p>
      </div>
      <div>
          <v-row>
              <v-col lg=12 cols=12 class="mt-5">
                  <v-card id="datosConfiguracion">
                      <v-card-title class="pa-5 pb-3 justify-center primary" id="datosConfiguracionTitulo" >
                          <v-toolbar-title style="color: white">Configurar visibilidad por estado </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon :color="'#FFFFFF'">mdi mdi-cog</v-icon>
                      </v-card-title>
                      <v-card-text class="pa-5 pt-4">
                          <v-row>
                              <v-col md="6" offset-md="3">
                                  <vs-list>
                                      <vs-list-item title="Usuario: " :subtitle="uslogin"></vs-list-item>
                                      <vs-list-item title="Estados visibles: ">
                                          <v-tooltip top>
                                              <template v-slot:activator="{ on, attrs }">
                                                  <v-btn 
                                                      v-bind="attrs" v-on="on"
                                                      color="success" class="mr-1"
                                                      @click="agregar()"
                                                      small
                                                      fab
                                                      dark
                                                      :disabled="!mostrarboton"
                                                      >
                                                      <v-icon>mdi-plus</v-icon>
                                                  </v-btn>
                                              </template>
                                              <span>Agregar</span>
                                          </v-tooltip>
                                          <v-tooltip top >
                                              <template v-slot:activator="{ on, attrs }">
                                                  <v-btn 
                                                      v-bind="attrs" v-on="on"
                                                      :disabled="mostrareliminar"
                                                      color="secondary" class="mr-1"
                                                      v-on:click="eliminar()"
                                                      small
                                                      fab
                                                      dark
                                                      v-show="btneliminar"
                                                  >
                                                  <v-icon>mdi-delete</v-icon>
                                                  </v-btn>
                                              </template>
                                              <span>Eliminar</span>
                                          </v-tooltip>
                                      </vs-list-item>
                                      <v-spacer></v-spacer>
                                      <div v-if="mostraragregar" class="mt-2 mb-4">
                                          <vs-list>
                                              <span style="font-weight: bold;">Seleccionar Estado: </span>
                                              <multiselect v-model="estados.esclave"
                                                  deselect-label="No se puede remover el valor seleccionado"
                                                  selected-label="Seleccionado"
                                                  :close-on-select="false"
                                                  :clear-on-select="true"
                                                  select-label="Seleccione el estado"
                                                  track-by="esclave" label="esnombre"
                                                  placeholder="Seleccione una opción"
                                                  :options="estados.opcionesEstados"
                                                  :multiple="true"
                                                  dense>
                                              </multiselect>
                                              <span v-if="validaesclave" class='spanError' style="color:#FF5C93; font-size:11px" >Campo requerido</span>
  
                                              <v-row justify="end" class="mb-8 mt-2">
                                                  <v-tooltip top>
                                                      <template v-slot:activator="{ on, attrs }">
                                                          <v-btn 
                                                              v-bind="attrs" v-on="on"
                                                              color="#536DFE" class="mr-1"
                                                              v-on:click="guardar()"
                                                              small
                                                              fab
                                                              dark
                                                              :disabled="disabled"
                                                          >
                                                          <v-icon>mdi-content-save</v-icon>
                                                          </v-btn>
                                                      </template>
                                                      <span>Guardar</span>
                                                  </v-tooltip>
  
                                                  <v-tooltip top>
                                                      <template v-slot:activator="{ on, attrs }">
                                                          <v-btn 
                                                              v-bind="attrs" v-on="on"
                                                              color="secondary" class="mr-1"
                                                              v-on:click="cancelar()"
                                                              small
                                                              fab
                                                              dark
                                                              :disabled="disabled"
                                                          >
                                                          <v-icon>mdi-close</v-icon>
                                                          </v-btn>
                                                      </template>
                                                      <span>Cancelar</span>
                                                  </v-tooltip>
                                              </v-row>
                                          </vs-list>
                                      </div>
                                      <v-spacer></v-spacer>
                                      <v-data-table 
                                          v-if="this.listadoEstados.length > 0"
                                          :headers="headers"
                                          :items="listadoEstados"
                                          :items-per-page="20"
                                          :show-select="!mostraragregar"
                                          class="elevation-1"
                                          no-data-text="No hay datos disponibles"
                                          :footer-props="{
                                          'items-per-page-options': [20, 50, 100],
                                          'items-per-page-text':'Registros por página'
                                          }"
                                          v-model="selectesclave"
                                      >
                                  </v-data-table>
                                  <span v-else style="font-size: 16px; font-weight: 700;">Usted puede ver todos los estados.</span>
                                  </vs-list>
                              </v-col>
                          </v-row>
                      </v-card-text>
                  </v-card>
              </v-col>
          </v-row>
      </div>
    </v-container>
  </template>
  
  <script>
  import { mapState, mapMutations } from 'vuex';
  import Config from '@/services/configuracion/Configuracion.service.js';
  
  export default {
      data: () => ({
          showcargando: true,
          uslogin:null,
          listadoEstados:[],
          headers:[
              { text: 'ID', value: 'id', class: "text title"},
              { text: 'Estado', value: 'esnombre', class: "text title"},
          ],
          estados: 
          {
              opcionesEstados: [],
              esclave: '',
              esnombre: ''
          },
          mostraragregar:false,
          mostrarboton:true,
          validaesclave:false,
          mostrareliminar:false,
          disabled:false,
          selectesclave:[],
          btneliminar:false,
  
      }),
      watch: {
          'estados.esclave'(val) {
              if(val != ''){
                  this.validaesclave = false
              }
          },
          'listadoEstados'(val){
              if(val.length == 0){
                  this.btneliminar = false;
              }
          },
          'selectesclave'(val){
              if(val.length == 0){
                  this.btneliminar = false;
              }else{
                  this.btneliminar = true;
              }
          }
      },
      computed: {
          ...mapState({ drawer: state => state.drawer }),
          ...mapState(['domain', 'informationPage']),
          DRAWER_STATE :{
          get() {
              return this.drawer
          },
          }
      },
      methods: {
          ...mapMutations('Busqueda', ['mostrarDialog']),
          async ObtenerDatos(){
              await Config.ObtenerUsuario(this);
              this.listadoEstados = await Config.ListadoEstados(this);
              this.showcargando = false
          },
          async eliminar(){
              let esclave_string = '';
              let esclaves = []
              for(let i = 0; i < this.selectesclave.length; i++){
                  esclaves.push(this.selectesclave[i].id)
              }
              esclave_string = esclaves.toString()
  
              this.$swal({
                  position: 'center',
                  title: 'Eliminando estado(os), espere un momento...',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                      this.$swal.showLoading();
                  }
              });
              let respuesta = await Config.EliminarEstado(this, esclave_string);
              if(respuesta.length == 0){
                  this.$swal({
                      position: 'center',
                      icon: 'success',
                      title: 'Éxito',
                      text: 'Se eliminó el(los) estado(os) con éxito.',
                      showConfirmButton: true,
                      allowOutsideClick: false,
                      timer: 3000
                  }).then(async (result) => {
                      if (result.isConfirmed) {
                      }
                  })
                  setTimeout(async () => {
                  }, 3000);
  
                  this.listadoEstados = await Config.ListadoEstados(this);
                  Config.CatalogoEstados(this);
                  this.selectesclave=[];
              }
  
          },
          agregar(){
              this.mostraragregar = true;
              this.mostrarboton = false;
              this.mostrareliminar = true;
          },
          cancelar(){
              this.mostrarboton = true;
              this.mostraragregar = false;
              this.estados.esclave = ''
              this.validaesclave = false;
              this.mostrareliminar = false;
          },
          async guardar(){
              let esclave_string = '';
              let esclaves = []
              if(this.estados.esclave.length != 0){
                  for(let i = 0; i < this.estados.esclave.length; i++){
                      esclaves.push(this.estados.esclave[i].esclave)
                  }
                  esclave_string = esclaves.toString()
                  this.disabled=true;
                  this.$swal({
                      position: 'center',
                      title: 'Guardando el(los) estado(os), espere un momento...',
                      allowEscapeKey: false,
                      allowOutsideClick: false,
                      didOpen: () => {
                          this.$swal.showLoading();
                      }
                  });
                  let resp = await Config.AgregarEstado(this,esclave_string);
                  if(resp.length == 0){
                      this.$swal({
                          position: 'center',
                          icon: 'success',
                          title: 'Éxito',
                          text: 'Se guardó el(los) estado(os) con éxito.',
                          showConfirmButton: true,
                          timer: 3000,
                          allowOutsideClick: false
                      }).then(async (result) => {
                          if (result.isConfirmed) {
                              
                              this.disabled = false
                          }
                      })
                      setTimeout(async () => {
                          this.disabled = false
                      }, 3000);
                      this.listadoEstados = await Config.ListadoEstados(this);
                      this.cancelar();
                      Config.CatalogoEstados(this);
                  }
              }else{
                  this.validaesclave = true;
              }
          }
      },
      async mounted(){
          Config.CatalogoEstados(this);
          this.ObtenerDatos()
      }
  }
  </script>
  
  <style lang="scss">
      #datosConfiguracion .vs-list--title{
          font-size: 12px;
          font-weight: 100 !important;
      }
      #datosConfiguracion .vs-list--subtitle{
          font-size: 20px;
          font-weight: 700;
      }
      #datosConfiguracion .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
          background-color: rgba(159, 156, 156, 0.68) !important;
      }
      /* Por debajo de 400px */
      @media screen and (max-width: 500px){
          #datosConfiguracionTitulo .v-toolbar__title{
              font-size: 1rem;
          }
      }
     
  </style>